module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAQAAABHeoekAAAAAXNSR0IArs4c6QAAATBJREFUGBkFwTGIzXEAB/DPwmRguUyYJBNXUmd4Ukq6RQwGVzJSVruUwaaU5Q3nDEyik+46uYnFmbzS/b6/979Hr+Tu5Sl1Svn5fADkXN5knB/Zzjhv6zwAoC5lt67UG2V280RZqK/q77wEQLayUw8BQGbqMFNAnuUPUE7mYX2UOSDjvEPm0kYHoN5Jy1pdSSv34eOetFyS91mH0ksrPSizaeUK5Hkiv3IV8iHLAKWfL1B6ZaJMumOQz6UPkLvZgu5gqjKpR6HcSgNIyz3ITKpM62Ugi+lyu9zMIK+BnMm2fCqrUE9lPS2jdGnZKGchi/lqeD6NejEtj7v9MNiXB2m5Tlq5hrqUnxltngaAcjzf8j3LgEzTAACyk38AyJP8LU/rfHdkeDgXSj+7eTHYC/8B6ePIepVLhwUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Administration_icon.png
// module id = b+Fi
// module chunks = 2